import type { SanitizedHtml } from '@hc-frontend/core-types';
import type { Prospect } from '@hc-frontend/core-types';
import { encodeForHtml, sanitizeHtml } from '@hc-frontend/core-utils-format';

type ReplaceParamsProps = {
  lead: Prospect | undefined;
  partnerName: string | undefined;
  dynamicText: string | undefined;
};

export function replaceDynamicTextProps(params: ReplaceParamsProps) {
  const { lead, partnerName, dynamicText } = params;

  if (!dynamicText) {
    return '';
  }

  let text = dynamicText;
  text = text.replace(
    '{email_address}',
    lead?.contactInformation?.email ?? 'your email address',
  );

  text = text.replace(
    ', {first_name}',
    lead?.contactInformation?.firstName
      ? `, ${lead?.contactInformation?.firstName}`
      : '',
  );

  text = text.replace(
    '{first_name}, ',
    lead?.contactInformation?.firstName
      ? `${lead?.contactInformation?.firstName}, `
      : '',
  );

  text = text.replace('{partner_name}', partnerName ?? '');

  return text;
}

/**
 * HTML-safe variant of {@link replaceDynamicTextProps} for use with
 * `dangerouslySetInnerHTML`. User-supplied values are HTML-encoded before
 * interpolation so they cannot introduce markup, then the full string is
 * run through the xss sanitizer to strip disallowed tags from the template.
 *
 * @returns {@link SanitizedHtml} safe to pass to `dangerouslySetInnerHTML.__html`
 */
export function replaceDynamicHtmlProps(
  params: ReplaceParamsProps,
): SanitizedHtml {
  const { lead, partnerName, dynamicText } = params;

  if (!dynamicText) {
    return sanitizeHtml('');
  }

  let text = dynamicText;
  text = text.replace(
    '{email_address}',
    encodeForHtml(lead?.contactInformation?.email ?? 'your email address'),
  );

  text = text.replace(
    ', {first_name}',
    lead?.contactInformation?.firstName
      ? `, ${encodeForHtml(lead.contactInformation.firstName)}`
      : '',
  );

  text = text.replace(
    '{first_name}, ',
    lead?.contactInformation?.firstName
      ? `${encodeForHtml(lead.contactInformation.firstName)}, `
      : '',
  );

  text = text.replace('{partner_name}', encodeForHtml(partnerName ?? ''));

  return sanitizeHtml(text);
}
